var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-zoomer",class:{ 'for-engage': _vm.engageSection },style:(_vm.style),on:{"click":_vm.click,"mouseenter":_vm.enter,"mousemove":_vm.conditionalClose,"mouseleave":_vm.remove}})}
var staticRenderFns = []

export { render, staticRenderFns }